import { render, staticRenderFns } from "./BlockQuote.vue?vue&type=template&id=8761e14c&"
import script from "./BlockQuote.vue?vue&type=script&lang=js&"
export * from "./BlockQuote.vue?vue&type=script&lang=js&"
import style0 from "./BlockQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports